import { Button } from "@/shared/ui/button";
import {
  Dialog,
  DialogClose,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from "@/shared/ui/dialog"
import UploadImageInput from "../UploadImageInput";
import { useState } from "react";
import { Template } from "../../api/templates";
import ImageGrid from "../ImageGrid";
import { useGetGallery } from "../../api/templates";
import EditTextDialog from "./EditTextDialog";

type Props = {
  event_id: number,
  template: Template,
  post_image_id: number,
  isCarousel: boolean,
  trigger: JSX.Element,
  open: boolean,
  openTextEditor: boolean
  setOpen: (val: boolean) => void
}

const ImageUploadDialog = ({ trigger, event_id, template, post_image_id, isCarousel, setOpen, open, openTextEditor }: Props) => {

  const [showUpload, setShowUpload] = useState(false)

  const { hasNextPage, gallery, fetchNextPage } = useGetGallery(true, template.template_name)

  const [selected, setSelected] = useState<{ image_id: number, image_url: string } | undefined>(undefined)

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogTrigger asChild>
        {trigger}
      </DialogTrigger>
      <DialogContent className="max-w-5xl flex flex-col gap-2 pt-5 h-[90vh] overflow-hidden !rounded-3xl">
        <DialogHeader>
          <DialogTitle>Edit Image</DialogTitle>
        </DialogHeader>
        {showUpload &&
          <UploadImageInput
            image_id={post_image_id}
            event_id={event_id}
            template_name={template.template_name}
            onShowUploadChange={(val: boolean) => setShowUpload(val)} />
        }
        {!showUpload && (
          <div className="w-full p-6 border rounded-xl h-[80vh] overflow-hidden">
            <div className="w-full flex flex-col sm:flex-row sm:justify-between gap-3 sm:items-center">
              <h3 className="font-montserrat font-medium py-3 text-2xl">Select a Template</h3>
              <Button variant="outline" className="rounded-full border border-purple-400" onClick={() => setShowUpload(true)}>Upload you own</Button>
            </div>
            <ImageGrid fetchNextPage={fetchNextPage} hasNextPage={hasNextPage} selected={selected} onSelect={(image: { image_id: number, image_url: string }) => setSelected(image)} galleryImages={gallery ? gallery : []} />
          </div>
        )}
        <DialogFooter>
          <DialogClose asChild>
            <Button className="rounded-full border border-purple-500" variant="outline">Cancel</Button>
          </DialogClose>
          {selected &&
            <EditTextDialog
              openTextEditor={openTextEditor}
              setOpen={setOpen}
              isCarousel={isCarousel}
              post_image_id={post_image_id}
              image_url={selected.image_url}
              image_id={selected.image_id}
              event_id={event_id}
              template_id={template.template_id}
              trigger={
                <DialogClose asChild>
                  <Button
                    type="button"
                    className="rounded-full border border-purple-500" variant="outline">Next</Button>
                </DialogClose>
              }
            />
          }
        </DialogFooter>
      </DialogContent>
    </Dialog>
  )
}

export default ImageUploadDialog;
